import React, { Component } from 'react';
import { Layout } from '../../Common/Component';
import * as yup from 'yup';
import map from 'lodash/map';
import {isEmpty} from "lodash";

const map_scorpio_channel = [
  {id: 1, value: "brochure", name:"Brochure"},
  {id: 2, value: "organic_search", name:"Organic Search"},
  {id: 3, value: "paid_search", name:"Paid Search"},
  {id: 4, value: "referral", name:"Referral"},
  {id: 5, value: "direct", name:"Direct"},
  {id: 6, value: "spirit_magazine", name:"Spirit Magazine"},
  {id: 7, value: "facebook", name:"Facebook"},
  {id: 8, value: "local_paid_search", name:"Local Paid Search"}
];
class CheckZip extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      zipcode: '',
      email: '',
      loader: false,
      scorpion_id: null,
      is_send_email: true,
      scorpion_channel: {}
    };
  }

  UNSAFE_componentWillReceiveProps = (props) => {

    const {zipcode, scorpion_id} = this.state;
    
    if (Object.keys(props.ZipcodeCheck.data).length > 0 && zipcode && zipcode != '' &&
      props.ZipcodeCheck.data.results && props.ZipcodeCheck.data.results.length > 0)
    {
      this.props.history.replace('', null);
      this.props.history.push('/services');
      const data = {
        zipcode: this.state.zipcode,
        uuid: props.ZipcodeCheck.data.results[0].uuid,
        annual_prepay_discount: props.ZipcodeCheck.data.results[0].annual_prepay_discount,
        state: props.ZipcodeCheck.data.results[0].state,
        city: props.ZipcodeCheck.data.results[0].city
      };

      sessionStorage.setItem('area', JSON.stringify(data));
      this.setState({loader: false});
    } else if(scorpion_id !== null || (zipcode !== '')){
      this.setState({
        step: 2,
        loader: false,
      });

      sessionStorage.clear();
    } else {
      this.setState({
        step: 1,
        loader: false,
      });
    }

    if (props.ZipcodeCheck.errors && Object.keys(props.ZipcodeCheck.errors).length > 0) 
    {
      this.setState({
        step: 1,
        loader: false,
      });
    }

    if (props.enquiry.data && Object.keys(props.enquiry.data).length > 0) {
      this.setState({
        errors: {},
        step: 1,
        zipcode: '',
        email: '',
        loader: false,
      });
    }
  };

  componentDidMount = () => {
    // From WP side to FE
    if (this.props?.location?.search && this.props?.location?.search.search("=") > -1 ||
      this.props?.location?.pathname && this.props?.location?.pathname.search("=") > -1)
    {
      let temp_scorpion_id = null;
      let temp_zipcode = null;

      if(this.props?.location?.search && this.props?.location?.search !== "")
      {
        let search_params = this.props?.location?.search?.split("?")[1].split("&"); 

        map(search_params, (search_param) => {
          let key = search_param.split("=")[0];
          let value = search_param.split("=")[1];

          if (key === "sa" || key === "scorpion_id")
          {
            temp_scorpion_id = value;
          } 
          if (key === "zipcode") {
            temp_zipcode = value;
          }
        });
      }
      else if(this.props?.location?.pathname)
      {
        const start = (this.props?.location?.pathname?.indexOf("&sa=") + 4);
        const end = this.props?.location?.pathname?.indexOf("&sd");

        temp_scorpion_id = this.props?.location?.pathname?.substring(start, end);
      }
      
      if (temp_zipcode !== null && temp_zipcode.length === 5) {
        this.props.checkZipCode({
          addressable_zip_codes__contains: temp_zipcode,
          close: false
        });

        this.setState({
          zipcode: temp_zipcode || '',
          loader: true
        });
      }
      else
      {
        this.props.history.push('/');
      }

      if (temp_scorpion_id){
        this.setState({scorpion_id: temp_scorpion_id});
        localStorage.setItem('scorpion_id', temp_scorpion_id);
      }
    }

    const substr = this.props.location.pathname.substring(this.props.location.pathname.indexOf('&s=')); 

    if(substr.length)
    {
      let scorpion_channel_number = substr.substring(3, 5);

      if(scorpion_channel_number.substring(1) === '&')
      {
        const number = scorpion_channel_number.substring(0,1);

        if(number < 1 || number > 8)
        {
          scorpion_channel_number = 9;
        }
        else
        {
          scorpion_channel_number = number;
        }
      }
      else
      {
        scorpion_channel_number = 9;
      }

      localStorage.setItem("scorpion_channel", scorpion_channel_number);
    }

    this.zipcodeInput && this.zipcodeInput.focus();
  };

  // check for logged in user zipcode
  checkedLoggedInUserZipcode = (zipCode) => {
    let authUser = JSON.parse(localStorage.getItem('userKey'))
    if (!isEmpty(authUser)) {
      if (authUser.user.zip_codes) {
        return authUser.user.zip_codes.includes(zipCode);
      } else {return false}
    }
    return true;
  }

  // Zipcode Submit
  onZipSubmit = (e) => {
    e.preventDefault();
    const { zipcode } = this.state;

    if (zipcode && zipcode.length > 4) {
      const ZipSchema = yup.object().shape({
        zipcode: yup
          .string()
          .required('Your ZIP code is invalid.')
          .min(5, 'Your ZIP code is invalid.')
          .max(5, 'Your ZIP code is invalid.'),
      });

      const ZiptData = { zipcode };

      // check validity
      const err_data = {};
      let IsValid;

      ZipSchema.isValid(ZiptData).then(function (valid) {
        IsValid = valid;
      });

      const self = this;

      setTimeout(() => {
        if (IsValid) {
          this.setState({
            loader: true,
            errors: {},
          });
          if (this.checkedLoggedInUserZipcode(zipcode)) {
            this.props.checkZipCode({
              addressable_zip_codes__contains: zipcode,
              close: false
            });
          } else {
            this.setState({step: 2, loader: false})
          }

        } else {
          this.setState({ loader: false });
          ZipSchema.validate(ZiptData, { abortEarly: false }).catch(
            function (err) {
              map(err.inner, (item) => {
                err_data[item.path] = item.message;
              });
              self.setState({
                errors: err_data,
              });
            }
          );
        }
      }, 100);
    }
  };

  // Email Submit
  onEmailSubmit = (e) => {
    e.preventDefault();
    this.setState({loader: true});

    let { zipcode, email } = this.state;
    let scorpion_id = localStorage.getItem('scorpion_id');
    const params = { email, zip_code: zipcode, scorpion_id: scorpion_id };

    this.props.nonServiceableEnquiry(params);
  };

  // Email Validation
  emailValidation = () => {
    const { email } = this.state;
    const ZipSchema = yup.object().shape({
      email: yup.string().email(),
    });
    const ZiptData = { email };

    // check validity
    let IsValid;
    ZipSchema.isValid(ZiptData).then(function (valid) {
      IsValid = valid;
    });

    const self = this;
    setTimeout(() => {
      if (IsValid) {
        this.setState({
          errors: {},
          is_send_email: false,
        });

      } else {
        this.setState({ loader: false });
        ZipSchema.validate(ZiptData, { abortEarly: false }).catch(
          function () {
            self.setState({
              is_send_email: true,
            });
          }
        );
      }
    }, 100);
  }

  render() {
    const { step, loader, zipcode, is_send_email } = this.state;
    let UserDetails = JSON.parse(localStorage.getItem('userKey')) || null;
    
    return (
      <Layout>
        <div className='page_inner_content'>
          <div className='zip_code_wrapper'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-6 col-lg-5'>
                  <div className='center_card'>
                    {step === 1 ? (
                      <div className='zip_card_box box_1'>
                        <h1>
                          Take back your backyard!
                        </h1>
                        <p className='sub_title'>
                          Get a FREE - FAST service quote now!
                        </p>
                        <form onSubmit={(e) => { this.onZipSubmit(e); }}>
                          <div className='form-group'>
                            <input
                              type='text'
                              ref={(input) => { this.zipcodeInput = input; }}
                              inputMode="numeric"
                              onChange={(e) => {
                                this.setState({ [e.target.name]: e.target.value, });
                              }}
                              max='5'
                              maxLength='5'
                              onPaste={(event) => {
                                if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                  event.preventDefault();
                                }
                              }}
                              onKeyPress={(e) => {
                                const pattern = /[0-9]/;
                                const inputChar = String.fromCharCode(e.charCode);
                                if (!pattern.test(inputChar)) {
                                  // invalid character, prevent input
                                  e.preventDefault();
                                }
                              }}
                              className='form-control'
                              name='zipcode'
                              placeholder='Enter ZIP Code'
                            />
                           
                          </div>
                          <div className='form-group'>
                            <button disabled={zipcode.length !== 5} type='submit' className='btn check_btn btn-block'>
                              Check Availability
                            </button>
                          </div>
                        </form>
                        {!UserDetails ?
                          <div>
                            <span className='allready_account'>
                              Already have an account?
                              <a href='/login'>Log in.</a>
                            </span>
                            <span className='allready_account additional_text'>
                              By completing this form and submitting the information above, you agree that we and/or the local DoodyCalls location may call 
                              (including through a prerecorded message or autodialer) or send text messages to you regarding your request and/or 
                              your account at the number you provide or at any number we and/or the local DoodyCalls location have for you.  
                              Message frequency varies.  Message and data rates may apply.  Text STOP at any time to cancel.<a href='https://www.doodycalls.com/privacy-policy/'>Privacy Policy.</a> Each location independently owned and operated.
                            </span>
                          </div> : ''}
                      </div>
                    ) : step === 2 ? (
                      <div className='zip_card_box  box_2'>
                        <h1>
                          Doggone it!
                        </h1>
                        <p className='sub_title'>
                          We are not providing service to this zip code yet, but we hope to soon!
                        </p>
                        <p className='sub_title'>
                          Enter your email address to stay connected. We will be sure to let you know when service becomes available.
                        </p>
                        <form>
                          <div className='form-group'>
                            <input
                              type='text'
                              className="form-control"
                              onChange={(e) => {
                                this.setState({ [e.target.name]: e.target.value, },
                                  () => {
                                    this.emailValidation();
                                  });

                              }}
                              name='email'
                              placeholder='Email Address'
                            />
                          </div>
                          <div className='form-group'>
                            <button
                              type='submit'
                              disabled={is_send_email}
                              className='btn check_btn btn-block'
                              onClick={(e) => { this.onEmailSubmit(e); }}>
                              Keep Me Updated!
                            </button>
                          </div>
                        </form>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          loader && (
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
          )
        }
      </Layout >
    );
  }
}

export default CheckZip;